export default "__VITE_ASSET__CFaE7xKY__"